import { render, staticRenderFns } from "./snapshotList.vue?vue&type=template&id=c8331a1a&"
import script from "./snapshotList.vue?vue&type=script&lang=js&"
export * from "./snapshotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports